import React from 'react';
import '../less/list.less';
import Item from '../views/item.c';

export default function template() {
    const {collection, card} = this.props;
    let content = null;
    if (collection && collection.length) {
        content = collection.map(model => {
            return <Item key={model.id} {...this.props} model={model} card={card} />;
        });
    } else {
        content = (
            <div className="list-empty">
                <h2>{this.l10n('STATEMENTS_LIST_EMPTY')}</h2>
            </div>
        );
    }
    return <div className="module-statements-list">{content}</div>;
}
